import React, { useEffect, useState } from "react";
import Modal from "../common/Modal/Modal";
import MHeader from "./common/MHeader";
import MFooter from "./common/MFooter";
import { ReactComponent as CloseIcon } from "./../../resources/images/icons/modalCloseIcon.svg";
import { JobsDataType } from "../../types/api-response";
import { useExpireJobMutation } from "../../redux/apis/manageJobPostingHooks";
// import CustomSnackbar from "../common/Snackbar/CustomSnackbar";
import { toast } from "react-toastify";
import { formatDate } from "../../utils";
import getMappedJobType from "../common/utils/getMappedJobType";

interface Props {
  isOpen: boolean;
  setIsOpen: Function;
  modalData?: JobsDataType[] | null;
  setSelectedRowData?: Function;
}

const ExpireJobsModal = ({
  isOpen,
  setIsOpen,
  modalData,
  setSelectedRowData = () => {},
}: Props) => {
  const [jobIds, setJobIds] = useState<any>([]);
  const [expireJob, { isError, isSuccess, isLoading, data, error }] =
    useExpireJobMutation();
  // const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
    // setSelectedRowData(null);
  };

  // const handleExpire = async () => {
  //   const response = await expireJob(jobIds);
  //   console.log({ response, isSuccess, isError, error });

  //   if (isSuccess) {
  //     handleSnackbarOpen();
  //     handleClose();
  //   } else if (isError) {
  //     handleSnackbarOpenWithError();
  //     handleClose();
  //   }
  // };

  const handleExpire = async () => {
    const idsToExpire = modalData ? modalData.map((row) => row.jobId) : jobIds;

    try {
      const result = await expireJob(idsToExpire).unwrap();
      if (isSuccess || result.length >= 1) {
        toast.success("Job(s) Expired Successfully", {
          autoClose: 5000,
          position: "bottom-left",
          toastId: "success-toast-custom",
        });
        if(setSelectedRowData) {
          setSelectedRowData([]);
        }
        handleClose();
      } 
      // else if (isError) {
      //   toast.error("Error expiring job(s)!", {
      //     autoClose: 5000,
      //     position: "bottom-left",
      //     toastId: "error-toast-custom",
      //   });
      //   handleClose();
      // }
    } catch (error) {
      toast.error("Error expiring job(s)!", {
        autoClose: 5000,
        position: "bottom-left",
        toastId: "error-toast-custom",
      });
      handleClose();
    }
  };

  // const handleSnackbarOpen = () => {
  //   setSnackbarOpen(true);
  // };

  // const handleSnackbarOpenWithError = () => {
  //   setSnackbarOpen(true);
  // };

  // const handleSnackbarClose = () => {
  //   setSnackbarOpen(false);
  // };


  const Header = (
    <MHeader>
      <div className="only-heading">
        <span className="mjp-modal-text-header">Expire?</span>
      </div>
    </MHeader>
  );

  const Footer = (
    <MFooter>
      <div className="expire-jobs-footer">
        <div style={{ width: "25%" }}>
          <button
            className="foundit-button primaryButton medium full-width"
            onClick={handleExpire}
          >
            Expire
          </button>
        </div>
      </div>
    </MFooter>
  );

  return (
    <React.Fragment>
      <Modal
        modalId="mjp-modal-expire-jobs"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        header={Header}
        footer={Footer}
        closeIcon={<CloseIcon />}
        width="800px"
      >
        <div className="mjp-modal-body expire-jobs-body">
          <div className="mjp-modal-body-greybox">
            <h5>Do you want to expire the job(s)?</h5>
          </div>
          <div className="expire-jobs-list">
            <div className="jobs-list">
              {(modalData || []).map((row,index) => {
                const {jobPostingType, jobType} = row || {};
                const jobTypeName = jobPostingType=='SJS' ? getMappedJobType('SOCIAL') : getMappedJobType(jobType?.name);

                return (
                <div key={row?.title} 
                className={`single-row-container ${index < (modalData?.length  || 1) -1 ? 'single-row-border-bottom' : '' }`}
                >
                  <div>
                    <span className="expire-title">{row?.title}</span>{" "}
                    {jobTypeName && <span className="small-section">({jobTypeName})</span>}
                  </div>
                  <div className="small-section">
                    <span className="faded">Last Modified:</span>{" "}
                    {row?.updateDate && formatDate(row?.updateDate)}
                  </div>
                </div>
              )})}
            </div>
          </div>
        </div>
      </Modal>

      {/* <CustomSnackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={
          isError ? "Error expiring job(s)!" : "Job(s) Expired Successfully"
        }
        variant={isError ? "error" : "success"}
      /> */}
    </React.Fragment>
  );
};

export default ExpireJobsModal;
